var BlockView = require('views/block/base-block-view');
var EvaluationService = require('services/evaluation-service');

var EvaluationResults = BlockView.extend({
  className: 'evaluation-result',

  initialize: function () {
    this.model.set('cid', this.model.cid);
    const evaluationSlug = this.model.get('evaluation_slug');
    const questionSlugs = this.model.get('responses') || [];
    const response = EvaluationService.findEvaluationBySlug(evaluationSlug);
    if(response) {
      questionSlugs.forEach(qs => {
        const data = response.responseForQuestionBySlug(qs.question_slug);
        if(data) {
          const { answers, question } = data;
          if(question.response_type === 'multiple_selection') {
            this.model.set('answers', answers);
          } else {
            this.model.set('answer', answers);
          }
          this.model.set('question', question.text);
          this.model.set('allAnswers', question.answers);
        }
      });
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  play: function () {
    this.readyToGo();
  }
});

module.exports = EvaluationResults;
